var map = {
	"./CRH-Icon.svg": 4060,
	"./No results icon.svg": 158,
	"./icon-home-active-default.svg": 7515,
	"./icon-home-default.svg": 4042,
	"./icon-manager-active-default.svg": 2840,
	"./icon-manager-default.svg": 2975,
	"./icon-reports-active-default.svg": 197,
	"./icon-reports-default.svg": 9208,
	"./icon-resolutions-active-default.svg": 9377,
	"./icon-resolutions-default.svg": 6190,
	"./icon-search-active-default.svg": 698,
	"./icon-search-default.svg": 2357,
	"./icon-settings-active-default.svg": 5548,
	"./icon-settings-default.svg": 9137,
	"./icon-status-active-default.svg": 312,
	"./icon-status-default.svg": 4667,
	"./icon-todo-active-default.svg": 9344,
	"./icon-todo-default.svg": 6447
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8091;